<script lang="ts">
	interface Props {
		title: string
		action: string | (() => void)
		close: () => void
	}

	let { title, action, close }: Props = $props()

	let isAction = $derived(typeof action !== "string")
	let route: string = $derived(isAction ? "#" : (action as string))

	function onClick(e: MouseEvent) {
		if (isAction) e.preventDefault()
		else return
		;(action as () => void)()
		close()
	}
</script>

<a href={route} target="_blank" onclick={onClick}>
	{title}
</a>

<style>
	a {
		width: 100%;
		border: none;
		text-wrap: nowrap;
		color: var(--color-text-light);
	}
</style>
